module.exports = __webpack_public_path__ + "img/balance_sheet_manual_3.78536176.png";